import _pt from "prop-types";
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    zIndex: 1,
    fontSize: 18,
    fontWeight: 'bold',
    color: theme.palette.primary.contrastText,
    width: 38,
    height: 38,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundColor: theme.palette.background.greenSpring
  },
  completed: {
    backgroundColor: theme.palette.background.greenSpring
  }
}), {
  name: 'OriUiStepLabel'
});
export default function StepLabelComponent(_ref) {
  let completed = _ref.completed,
      active = _ref.active,
      icon = _ref.icon;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.root, {
      [classes.active]: active,
      [classes.completed]: completed
    })
  }, icon);
}
StepLabelComponent.propTypes = {
  active: _pt.bool.isRequired,
  completed: _pt.bool.isRequired,
  icon: _pt.node.isRequired
};